import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import Input from './Input';
import Select from './Select';
import PageSection from './PageSection';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class UserForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			countries: [],
			provinces: []
		};

		this.Auth = new AuthService();
	}

	componentDidMount() {
		this.Auth.fetch("/countries")
		.then(
			(result) => {
				if(result) {
					this.setState({
						countries: result
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);

		this.Auth.fetch("/provinces")
		.then(
			(result) => {
				if(result) {
					this.setState({
						provinces: result
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);
	}

	render() {
		const { user = {}, onChange } = this.props;
		let { countries = [], provinces = [] } = this.state;

		// convert lists to option lists for select element
		let countryOptions = [];
		for(let i=0; i<countries.length; i++) {
			countryOptions.push({
				value: countries[i].country_id,
				text: countries[i].country_name
			});
		}

		let provinceOptions = [];
		for(let i=0; i<provinces.length; i++) {
			if(user.country_id && user.country_id == provinces[i].country_id) {
				let province_name = provinces[i].province_abbreviation || provinces[i].province_name;
				provinceOptions.push({
					value: provinces[i].province_id,
					text: province_name
				});
			}
		}

		return (
			<form id="user-form" className="pp-user-form">
				<div className="pp-form-wrapper">

					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="first-name"
							htmlName="first_name"
							label="First Name"
							placeholderText="First Name"
							value={user.first_name}
							onChange={onChange}
							error={this.props.errors.first_name || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="last-name"
							htmlName="last_name"
							label="Last Name"
							placeholderText="Last Name"
							value={user.last_name}
							onChange={onChange}
							error={this.props.errors.last_name || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="company-name"
							htmlName="company"
							label="Company"
							placeholderText="Company"
							value={user.company}
							onChange={onChange}
							error={this.props.errors.company || false}
						/>
					</div>

				</div>

				<div className="pp-form-wrapper">

					<div className="pp-form-row">
						<Input
							type="email"
							htmlID="email"
							htmlName="pp_user_email"
							label="Email"
							placeholderText="Email"
							value={user.pp_user_email}
							onChange={onChange}
							error={this.props.errors.pp_user_email || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="office-phone"
							htmlName="phone"
							label="Office Phone"
							placeholderText="Office Phone"
							value={user.phone}
							onChange={onChange}
							error={this.props.errors.phone || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="website"
							htmlName="website"
							label="Website"
							placeholderText="Website"
							value={user.website}
							onChange={onChange}
							error={this.props.errors.website || false}
						/>
					</div>
				</div>

				{/*
				<div className="pp-form-wrapper">

					<div className="pp-form-row">
						<Select
							type="text"
							htmlID="country"
							htmlName="country_id"
							label="Country"
							value={user.country_id}
							options={countryOptions}
							onChange={onChange}
							error={this.props.errors.country_id || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="address"
							htmlName="street_address"
							label="Street Address"
							placeholderText="Street Address"
							value={user.street_address}
							onChange={onChange}
							error={this.props.errors.street_address || false}
						/>
					</div>
					<div className="pp-form-row">
						<Input
							type="text"
							htmlID="city"
							htmlName="city"
							label="City"
							placeholderText="City"
							value={user.city}
							onChange={onChange}
							error={this.props.errors.city || false}
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							type="text"
							htmlID="state"
							htmlName="province_id"
							label="State / Province"
							value={user.province_id}
							options={provinceOptions}
							onChange={onChange}
							error={this.props.errors.province_id || false}
						/>
					</div>
					<div className="pp-form-row-split">
						<Input
							type="text"
							htmlID="zip"
							htmlName="postal_code"
							label="Zip Code"
							placeholderText="Zip Code"
							value={user.postal_code}
							onChange={onChange}
							error={this.props.errors.postal_code || false}
						/>
					</div>

				</div>
				*/}
				
			</form>
		);
	}
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/UserForm.js